
import React from "react";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { useFormContext } from "react-hook-form";
import FormInput from "@/components/agent-upload/FormInput";
import CategorySelect from "@/components/agent-upload/CategorySelect";
import { AgentFormData } from "@/models/agent-form";

const BasicInfoSection: React.FC = () => {
  const form = useFormContext<AgentFormData>();
  
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Agent Name</FormLabel>
              <FormControl>
                <FormInput
                  id="name"
                  name="name"
                  label=""
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  placeholder="Give your agent a memorable name"
                  error={form.formState.errors.name?.message}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="category"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Category</FormLabel>
              <FormControl>
                <CategorySelect
                  value={field.value}
                  onChange={(value) => field.onChange(value)}
                  error={form.formState.errors.category?.message}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Short Description</FormLabel>
            <FormControl>
              <FormInput
                id="description"
                name="description"
                label=""
                value={field.value}
                onChange={(e) => field.onChange(e.target.value)}
                placeholder="A brief summary of what your agent does (will appear in search results)"
                error={form.formState.errors.description?.message}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </>
  );
};

export default BasicInfoSection;
